import React, { createContext, useContext } from "react";

const AuthContext = createContext(undefined);

export const AuthProvider = ({ children, user }: any) => (
  <AuthContext.Provider value={user}>{children}</AuthContext.Provider>
);

export const useAuth = () => useContext(AuthContext);
